<ng-template #toolbarContent>
  @if (toolbarButtonWrapperTemplate) {
    <rt-wysiwyg-toolbar
      [editorView]="editorView"
      [editorHasFocus]="hasFocus"
      [buttonWrapperTemplate]="toolbarButtonWrapperTemplate"
    />
  } @else {
    <rt-wysiwyg-toolbar [editorView]="editorView" [editorHasFocus]="hasFocus" />
  }
</ng-template>

<div #editor class="editor-container">
  <div [class.visible]="showSpinner" class="spinner-container">
    <rt-spinner variant="small-x" />
  </div>
</div>
@if (toolbarVisible()) {
  <div
    #toolbarContainer
    class="toolbar"
    [class.is-pinned]="toolbarIsPinned()"
    [class.no-shadow]="toolbarNoShadow()"
  >
    <ng-container [ngTemplateOutlet]="toolbarContent" />
  </div>
}
@if (toolbarRightVisible()) {
  <div class="toolbar">
    <ng-content select="toolbar-right" />
  </div>
}
<ng-container *ngTemplateOutlet="footerTmpl(); context: { toolbar: toolbarContent }" />
